import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import GalleryGrid from '../components/GalleryGrid';

export default function PLCSCADA() {
  const galleryImages = [
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/elkonstruktion-styretavle.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/hero-automation-engineering.jpg',
  ];

  return (
    <div className="bg-[#0b1017] text-slate-100 min-h-screen">
      <SEO
        title="PLC og SCADA programmering - JARCon ApS"
        description="PLC: Siemens, Mitsubishi, Allan Bradley mm. SCADA: Siemens WinCC, Indusoft, Wonderware mm. Stabil og modulær softwarearkitektur."
      />

      <PageHeader
        badge="Automation"
        title="PLC og SCADA programmering"
        subtitle="Siemens, Mitsubishi, Allan Bradley • Siemens WinCC, Indusoft, Wonderware"
        breadcrumbs={[
          { label: 'Automation', path: '/automation' },
          { label: 'PLC og SCADA' },
        ]}
        ctaText="Hør om PLC programmering"
        ctaLink="/kontakt"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8 space-y-8">
            <div className="p-8 rounded-xl bg-[#0e1622] border border-slate-800 space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-widest font-semibold block">
                Industriel softwarearkitektur
              </span>
              <h2 className="font-display text-2xl font-bold text-white">
                PLC og SCADA programmering
              </h2>
              <p className="text-slate-300 text-base leading-relaxed">
                PLC: Siemens, Mitsubishi, Allan Bradley mm.<br />
                SCADA: Siemens WinCC, Indusoft, Wonderware mm.
              </p>
              <p className="text-slate-400 text-sm leading-relaxed">
                Vi strukturerer PLC-koden efter gængse standarder med klare funktionsblokke, grundig kommentering og gennemtænkt fejllogik. Det gør maskinen intuitiv at betjene for operatører og hurtig at fejlfinde på for vedligeholdspersonalet.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800 space-y-4">
                <div className="w-10 h-10 rounded-lg bg-cyan-950/70 border border-cyan-500/30 text-cyan-400 flex items-center justify-center text-lg">
                  <i className="fa-solid fa-microchip" aria-hidden="true" />
                </div>
                <h3 className="font-display font-bold text-lg text-white">PLC Systemer</h3>
                <ul className="space-y-2 text-xs font-open-sans text-slate-300">
                  <li className="flex items-center gap-2">
                    <span className="text-cyan-400">•</span>
                    <span>Siemens (TIA Portal / Simatic S7)</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-cyan-400">•</span>
                    <span>Mitsubishi Electric (MELSEC)</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-cyan-400">•</span>
                    <span>Allan Bradley (Rockwell Automation)</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-cyan-400">•</span>
                    <span>Sikkerheds-PLC og nødstopskredse</span>
                  </li>
                </ul>
              </div>

              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800 space-y-4">
                <div className="w-10 h-10 rounded-lg bg-cyan-950/70 border border-cyan-500/30 text-cyan-400 flex items-center justify-center text-lg">
                  <i className="fa-solid fa-desktop" aria-hidden="true" />
                </div>
                <h3 className="font-display font-bold text-lg text-white">SCADA &amp; HMI</h3>
                <ul className="space-y-2 text-xs font-open-sans text-slate-300">
                  <li className="flex items-center gap-2">
                    <span className="text-cyan-400">•</span>
                    <span>Siemens WinCC</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-cyan-400">•</span>
                    <span>InduSoft Web Studio</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-cyan-400">•</span>
                    <span>Wonderware (InTouch / System Platform)</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-cyan-400">•</span>
                    <span>Alarmlister, trending og logning</span>
                  </li>
                </ul>
              </div>
            </div>

            <GalleryGrid
              title="PLC og styretavle galleri"
              subtitle="Styringskomponenter og tavlemontering"
              images={galleryImages}
            />
          </div>

          <div className="lg:col-span-4 space-y-6">
            <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
              <h3 className="font-display text-base font-bold text-white mb-4">
                Programmeringsprofil
              </h3>
              <ul className="space-y-3 text-xs font-open-sans text-slate-300">
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Siemens TIA Portal</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Mitsubishi PLC</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Allan Bradley PLC</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>WinCC, Indusoft, Wonderware</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Profinet, Ethernet/IP, Modbus</span>
                </li>
              </ul>
            </div>

            <div className="p-6 rounded-xl bg-gradient-to-br from-[#0e1622] to-[#070b10] border border-cyan-500/40 text-center space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-wider block font-semibold">
                Skal du have programmeret en PLC?
              </span>
              <p className="text-xs text-slate-300">
                JARCon hjælper med nyudvikling, fejlretning og opgradering af eksisterende styringer.
              </p>
              <Link
                to="/kontakt"
                className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-cyan-500 hover:bg-cyan-600 text-white font-bold text-xs uppercase tracking-wider transition-all"
              >
                <span>Kontakt os</span>
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
